import { V3Record } from 'data/helpers/V3Record.js'

export const AmbassadorRoute = V3Record('ambassadorRoute', {
  id: null,
  routeId: null,
  ambassadorRouteId: null,
  detailedDescription: null,
  subtitle: null
})
